

export const SOCKET = {
  ADJUDICATOR: "adjudicator",
  ADJUDICATOR_LOG_IN: "adjudicatorLogIn",
  ADJUDICATOR_LOG_OUT: "adjudicatorLogOut",
  ADJUDICATOR_SHEET: "adjudicatorSheet",
  ACK_ADJUDICATOR_SHEET: "ackAdjudicatorSheet",
  ADJUDICATOR_ROUND_RESULTS: "adjudicatorRoundResults",
  ADJUDICATOR_CURRENT_SCREEN: "adjudicatorCurrentScreen",
  JUDGES_LIST: "judgesList",
  TIMETABLE: "timetable",
  TIMETABLE_DETAILS: "timetableDetails",
  MONITOR_DETAILS: "monitorDetails",
  RESET_MONITOR: "resetMonitor",
  MESSAGE: "message",
  TASK_MANAGET_QUEUE: "taskManagerQueue",
  COMPETITION: "competition",
  ADJUDICATOR_WARNING: "adjudicatorWarning",
  MC_LOG_IN: "mcLogIn",
  MONITOR_LOG_IN: "monitorLogIn",
  RESEND_CONST_EMIT: "resendConstEmit",
  // Visual Control Events (LED/Broadcast)
  VISUAL_CONTROLLER_LOG_IN: "visualControllerLogIn",
  LED_LOG_IN: "ledLogIn",
  BROADCAST_LOG_IN: "broadcastLogIn",
  VISUAL_CONTROL: "visualControl",           // Command to change content on LED/Broadcast
  VISUAL_STATE: "visualState",               // Current state broadcast to all controllers
  JUDGES_STATUS: "judgesStatus",             // Judges status updates for chairperson/MC
} as const;

export default SOCKET;
type t = typeof SOCKET;
export type SocketType =  t[keyof t];